import { contain } from 'react-container-helper';
import { connect } from 'react-redux';

import { languagePathRedirect } from 'actions/i18n';
import { hotelPathRedirect } from 'actions/hotel';

import { lanMapRoute } from 'util/i18n';

import Navigation from './component';

const mapSetStateToProps = (_, { lanRoute, changeLanguage, changeHotel, ...props }) => ({
	lanRoute,

	...props,

	onLangSelect(option) {
		changeLanguage(option.value);
	},
	onHotelSelect(option) {
		changeHotel(option.value);
	},
});

const componentContainer = contain(undefined, mapSetStateToProps)(Navigation);

const mapStateToProps = ({ global: { lan }, hotel: { hotel } }) => ({
	language: lan,
	lanRoute: lanMapRoute(lan),
	hotel,
});

const mapDispatchToProps = dispatch => ({
	changeLanguage: language => dispatch(languagePathRedirect(language)),
	changeHotel: hotel => dispatch(hotelPathRedirect(hotel)),
});

export default connect(mapStateToProps, mapDispatchToProps)(componentContainer);



// WEBPACK FOOTER //
// ./src/components/molecules/Navigation/index.js